module.exports = __webpack_public_path__ + "img/lt.71aac735.svg";